import { render, staticRenderFns } from "./mailLList.vue?vue&type=template&id=48f0d11c&scoped=true"
import script from "./mailLList.vue?vue&type=script&lang=js"
export * from "./mailLList.vue?vue&type=script&lang=js"
import style0 from "./mailLList.vue?vue&type=style&index=0&id=48f0d11c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f0d11c",
  null
  
)

export default component.exports